import MultipleShops from "../../../components/Multipleshopprofile/MultipleShops";
import { GEM_SHOP_ALLOWED_CONNECT_TYPES } from "../../../constants/businessTypeConnectionRules";

const MineralsMining = () => {
  return (
    <div>
      <MultipleShops
        allowedConnectBusinessTypes={GEM_SHOP_ALLOWED_CONNECT_TYPES}
      />
    </div>
  );
};
export default MineralsMining;
